var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.029 2.53961C11.326 2.37465 11.6602 2.28809 12 2.28809C12.3398 2.28809 12.674 2.37465 12.971 2.53961L20.486 6.71361C20.6418 6.80025 20.7716 6.92697 20.862 7.08064C20.9524 7.23431 21 7.40934 21 7.58761V15.8226C20.9999 16.1793 20.9045 16.5294 20.7235 16.8367C20.5426 17.1441 20.2828 17.3975 19.971 17.5706L12.971 21.4606C12.674 21.6256 12.3398 21.7121 12 21.7121C11.6602 21.7121 11.326 21.6256 11.029 21.4606L4.029 17.5706C3.71736 17.3975 3.45763 17.1443 3.27671 16.8372C3.0958 16.53 3.00026 16.1801 3 15.8236V7.58761C2.99999 7.40934 3.04764 7.23431 3.13802 7.08064C3.22839 6.92697 3.3582 6.80025 3.514 6.71361L11.03 2.53961H11.029Z",
    stroke: "#778583",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V22M3 7L12 12L3 7ZM12 12L21 7L12 12Z",
    stroke: "#778583",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.5L16.5 4.5",
    stroke: "#778583",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.31f095b0bc31fca59ae5e4086eea4d22.svg";
export { ForwardRef as ReactComponent };